import React from 'react';
import { Card, CardContent, Typography, Box, TextField, Button, Chip } from '@mui/material';

const GastspielerSection = ({ gastData, newGastName, setNewGastName, handleAddGast }) => {
    return (
        <Card sx={{ mt: 4, borderRadius: "12px" }}>
            <CardContent>
                <Typography variant="h6" fontWeight="bold" gutterBottom>Gastspieler</Typography>
                <Box sx={{ display: 'flex', gap: 2, mb: 3 }}>
                    <TextField
                        size="small"
                        placeholder="Vorname Nachname"
                        value={newGastName}
                        onChange={(e) => setNewGastName(e.target.value)}
                        fullWidth
                        sx={{ bgcolor: 'background.paper' }}
                    />
                    <Button variant="contained" onClick={handleAddGast} disableElevation sx={{ borderRadius: "12px" }}>Gast Hinzufügen</Button>
                </Box>
                {gastData?.gastspieler?.length > 0 && (
                    <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: 1 }}>
                        {gastData.gastspieler.map(g => (
                            <Chip key={g.id} label={g.name} variant="outlined" />
                        ))}
                    </Box>
                )}
            </CardContent>
        </Card>
    );
};

export default GastspielerSection;
